var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"easy-with-greet d-flex align-end mt-2"},[_c('span',{staticClass:"easy-with-greet__text tp-text-body-2"},[_vm._v(" "+_vm._s(_vm.$t('generic.easyWith'))+" ")]),_c('GreetLogo',{attrs:{"width":55,"height":14,"color":_vm.color}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }